<div class="flex flex-row justify-between items-center pb-4">
    <h4 class="mb-2 font-semibold">Open Claims</h4>
    <div>
        <rcp-oup-stalled-claim-filter
            [filterId]="
                STALLED_CLAIM_FILTER_IDS.AGING_CLAIMS_SUMMARY
            "></rcp-oup-stalled-claim-filter>
    </div>
</div>
<div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-6 gap-5 min-h-[117px]"
    rcpComLoadingOverlay
    [isLoading]="isLoading">
    <!--AGE 0-30 SECTION-->
    <div
        *ngIf="!isLoading"
        class="swatch-green text-white flex flex-col space-y-2 cursor-pointer p-4 rounded-lg"
        (click)="goToClaimAgeFilter(1)">
        <div class="font-semibold">0-30 Days</div>
        <div class="leading-6">
            <span class="font-semibold text-[22px]">
                {{
                    calculateSummary('AGE_0_30').balance
                        | currency: 'USD' : 'symbol' : '1.2-2'
                }}
            </span>
            <span class="text-sm">
                ({{ calculateSummary('AGE_0_30').percentage.toFixed(1) }}%)
            </span>
        </div>
        <div class="text-sm">
            {{ calculateSummary('AGE_0_30').count }} Claims
        </div>
    </div>
    <!--AGE 31-60 SECTION-->
    <div
        *ngIf="!isLoading"
        class="swatch-yellow text-white flex flex-col space-y-2 cursor-pointer p-4 rounded-lg"
        (click)="goToClaimAgeFilter(2)">
        <div class="font-semibold">31-60 Days</div>
        <div class="leading-6">
            <span class="font-semibold text-[22px]">
                {{
                    calculateSummary('AGE_31_60').balance
                        | currency: 'USD' : 'symbol' : '1.2-2'
                }}
            </span>
            <span class="text-sm">
                ({{ calculateSummary('AGE_31_60').percentage.toFixed(1) }}%)
            </span>
        </div>
        <div class="text-sm">
            {{ calculateSummary('AGE_31_60').count }} Claims
        </div>
    </div>
    <!--AGE 61-90 SECTION-->
    <div
        *ngIf="!isLoading"
        class="swatch-orange text-white flex flex-col space-y-2 cursor-pointer p-4 rounded-lg"
        (click)="goToClaimAgeFilter(3)">
        <div class="font-semibold">61-90 Days</div>
        <div class="leading-6">
            <span class="font-semibold text-[22px]">
                {{
                    calculateSummary('AGE_61_90').balance
                        | currency: 'USD' : 'symbol' : '1.2-2'
                }}
            </span>
            <span class="text-sm">
                ({{ calculateSummary('AGE_61_90').percentage.toFixed(1) }}%)
            </span>
        </div>
        <div class="text-sm">
            {{ calculateSummary('AGE_61_90').count }} Claims
        </div>
    </div>
    <!--AGE 91-120 SECTION-->
    <div
        *ngIf="!isLoading"
        class="swatch-red text-white flex flex-col space-y-2 cursor-pointer p-4 rounded-lg"
        (click)="goToClaimAgeFilter(4)">
        <div class="font-semibold">91-120 Days</div>
        <div class="leading-6">
            <span class="font-semibold text-[22px]">
                {{
                    calculateSummary('AGE_91_120').balance
                        | currency: 'USD' : 'symbol' : '1.2-2'
                }}
            </span>
            <span class="text-sm">
                ({{ calculateSummary('AGE_91_120').percentage.toFixed(1) }}%)
            </span>
        </div>
        <div class="text-sm">
            {{ calculateSummary('AGE_91_120').count }} Claims
        </div>
    </div>
    <!--AGE 121+ SECTION-->
    <div
        *ngIf="!isLoading"
        class="swatch-dark-red text-white flex flex-col space-y-2 cursor-pointer p-4 rounded-lg"
        (click)="goToClaimAgeFilter(5)">
        <div class="font-semibold">121+ Days</div>
        <div class="leading-6">
            <span class="font-semibold text-[22px]">
                {{
                    calculateSummary('AGE_OVER_120').balance
                        | currency: 'USD' : 'symbol' : '1.2-2'
                }}
            </span>
            <span class="text-sm">
                ({{ calculateSummary('AGE_OVER_120').percentage.toFixed(1) }}%)
            </span>
        </div>
        <div class="text-sm">
            {{ calculateSummary('AGE_OVER_120').count }} Claims
        </div>
    </div>
    <!--TOTAL - ALL CLAIM SECTION-->
    <div
        *ngIf="!isLoading"
        class="swatch-gray text-white flex flex-col space-y-2 cursor-pointer p-4 rounded-lg"
        (click)="goToClaimStatusFilter()">
        <div class="font-semibold">Totals</div>
        <div class="leading-6">
            <span class="font-semibold text-[22px]">
                {{ totalBalance | currency: 'USD' : 'symbol' : '1.2-2' }}
            </span>
            <span class="text-sm">(100%)</span>
        </div>
        <div class="text-sm">{{ totalCount || 0 }} Claims</div>
    </div>
</div>
